/**
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License.
 */

// https://github.com/microsoft/CorrelationVector-JavaScript/blob/master/src/correlationVectorVersion.ts

export enum CorrelationVectorVersion {
    V1,
    V2,
}
